require('./insuranceRequestWizardStep2Related.scss');
require('./insuranceRequestWizardStep2Related.override.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { merge } = require('lodash');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @ constants
const { EVENTS_INSURANCE_HOME } = require('../../../insuranceConstants/insuranceRequestTags');
const { SECOND_STEP, THIRD_STEP, FOURTH_STEP, EURO_SYMBOL, POSTAL_CODE_REGEX } = require('constants/index');
const PROVINCES = require('constants/provinces');
const {
    CONTENT_SLIDER_CONFIG,
    CONTINENT_SLIDER_CONFIG,
    getPropertyTypeOptions,
    PROPERTY_CHARACTER,
    PROPERTY_TYPE,
    PROPERTY_USAGE,
    SIZE_SLIDER_CONFIG,
} = require('../../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCES_RECOMMENDATION_FACTORS,
    INSURANCE_RELATED_PRE_APPRAISAL_NOTIFICATION,
    INSURANCE_USABILITY_IMPROVEMENTS,
} = require('constants/flagBasedFeatures');

// @ commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKSliderInput = require('commonsComponents/OKSliderInput');

// @ components
const InsuranceRequestWizardGuide = require('./insuranceRequestWizardGuide');
const InsurancesRequestWizardStep2SliderLabel = require('./insurancesRequestWizardStep2SliderLabel');
const InsuranceRequestPostalCodePopulation = require('../insuranceRequestPostalCodePopulation/insuranceRequestPostalCodePopulation');

class InsuranceRequestWizardStep2Related extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            lowContinentWarningVisible: false,
            maxContentPassed: false,
            minContinentValue: CONTINENT_SLIDER_CONFIG.MIN,
            postalCode: props.immInsuranceWizardStep.get('postalCode'),
            updateValues: false,
            contentValueNotAlowed: false,
            setRecommendation: false,
        }

        this.handleChangePropertyCharacter = this.handleChangePropertyCharacter.bind(this);
        this.handleChangePostalCode = this.handleChangePostalCode.bind(this);
        this.handlePostalCodeErrorMessage = this.handlePostalCodeErrorMessage.bind(this);
        this.handleChangeContinent = this.handleChangeContinent.bind(this);
        this.handleChangeContent = this.handleChangeContent.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSelectPlanModal = this.handleSelectPlanModal.bind(this);
        this.buildContinentContentRelatedTitle = this.buildContinentContentRelatedTitle.bind(this);
        this.buildPropertyCharacterAndPropertyUsage = this.buildPropertyCharacterAndPropertyUsage.bind(this);
        this.buildStepTwoSubtitle = this.buildStepTwoSubtitle.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.saveAndRequestRecommendation = this.saveAndRequestRecommendation.bind(this);
    }

    componentWillMount() {
        const {
            immInsuranceWizardStep,
            isPostAppraisal,
            setData,
        } = this.props;

        this.getPostAppraisalValues(this.props);
        if ((!immInsuranceWizardStep.get('postalCode') && !this.getLivingPlaceData('postalCode')) || isPostAppraisal) {
            this.setState({ setRecommendation: true });
        }
        if (this.postalCodeBeforeAppraisal()) {
            setData(SECOND_STEP, {
                postalCode: this.getLivingPlaceData('postalCode')
            });
        }
    }

    componentDidMount() {
        const {
            getRecommendation,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardStep,
            isPostAppraisal,
            savePreviousId,
            setData,
        } = this.props;
        const content = immInsuranceWizardStep.get('content');
        let continent = null;
        const previousInsurance = immInsuranceState.getIn(['data', 'id']);
        savePreviousId(previousInsurance);

        if (isPostAppraisal) {
            const minPostAppraisalContinent = this.getMinContinent();
            continent = minPostAppraisalContinent;
            setData(SECOND_STEP, {
                continent
            });
        }
        const propertyType = immInsuranceWizardStep.get('propertyType');
        const propertyCharacter = immInsuranceWizardStep.get('propertyCharacter');
        const propertyUsage = immInsuranceWizardStep.get('propertyUsage');
        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);

        const data = {
            content,
            continent,
            propertyCharacter,
            propertyType,
            propertyUsage,
            provinceId: this.getProvinceId(),
            size: immInsuranceWizardStep.get('size'),
        };

        if (!propertyType && !isInsuranceUsabilityImprovementsEnabled) {
            setData(SECOND_STEP, {
                noValidateStep: true,
                propertyType: PROPERTY_TYPE.APARTMENT,
            });
        }

        if (isInsuranceUsabilityImprovementsEnabled) {
            setData(SECOND_STEP, {});
        }

        if (!isInsuranceUsabilityImprovementsEnabled && data.provinceId) {
            getRecommendation(data);
        }

        if (__CONTACT_CENTER__) {
            setData(THIRD_STEP, {
                coveragePlanModal: {},
                isQuotationDataChanged: false,
                quotationData: {}
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { updateValues, minContinentValue, setRecommendation } = this.state;
        const { immInsuranceState, setData, isPostAppraisal, immInsuranceWizardStep } = this.props;

        const nextRecommendationContent = nextProps.immInsuranceState.getIn(['recommendation', 0, 'content']);
        const nextSliderContent = nextProps.immInsuranceWizardStep.get('content');
        const nextContinent = nextProps.immInsuranceState.getIn(['recommendation', 0, 'continent']);
        const nextSliderContinent = nextProps.immInsuranceWizardStep.get('continent');

        const minimumValueContinent = nextProps.immInsuranceState.getIn(['recommendation', 0, 'minimumValueContinent']);
        const defaultMinimumValueContent = nextProps.immInsuranceState.getIn(['recommendation', 0, 'defaultMinimumValueContent']);
        const defaultMaxValueContent = nextProps.immInsuranceState.getIn(['recommendation', 0, 'defaultMaxValueContent']);
        const maxContentValidation = this.getMaxContentValue();

        const populationChanged = nextProps.immInsuranceWizardStep.get('populationValue');
        const currentPopulation = immInsuranceWizardStep.get('populationValue');

        if (
            updateValues &&
            nextProps.immInsuranceState.get('recommendation') !== immInsuranceState.get('recommendation')
        ) {

            const updateContentAndContinent = setRecommendation ||
                this.postalCodeHasDiscrepancy() &&
                nextSliderContent !== nextRecommendationContent;

            updateContentAndContinent && setData(SECOND_STEP, {
                continent: nextContinent < minContinentValue ? minContinentValue : nextContinent
            });

            const existSimulation = immInsuranceState.get('data');
            if (!(isPostAppraisal && existSimulation) && updateContentAndContinent) {
                setData(SECOND_STEP, {
                    content: nextRecommendationContent > maxContentValidation ? maxContentValidation : nextRecommendationContent
                });
            }

            if (this.postalCodeBeforeAppraisal() && nextSliderContent === nextRecommendationContent) {
                setData(SECOND_STEP, {
                    sliderPreAppraisalMessageContent: false,
                    sliderPreAppraisalMessageContinent: false,
                });
            }
            this.setState({ setRecommendation: true });
        }
        if (nextProps.isPostAppraisal !== isPostAppraisal) {
            this.getPostAppraisalValues(nextProps)
        }

        const lowContinentWarningVisible = nextSliderContinent < minimumValueContinent;
        const maxContentPassed = nextSliderContent >= maxContentValidation;

        this.setState({ maxContentPassed, lowContinentWarningVisible });

        if (isPostAppraisal || this.postalCodeHasDiscrepancy()) {
            const currentContent = immInsuranceWizardStep.get('content');
            const contentChanged = nextProps.immInsuranceWizardStep.get('content');

            if (!!currentContent && currentContent !== contentChanged) {
                this.setState({ contentValueNotAlowed: false });
                setData(SECOND_STEP, {
                    contentHasChanged: true
                });
            }

            const contentIsLessThanRecommendation = currentContent < defaultMinimumValueContent;
            const contentIsGreaterThanRecommendation = currentContent > defaultMaxValueContent;
            if (this.hasSimulation() && (contentIsLessThanRecommendation || contentIsGreaterThanRecommendation)) {
                let aproxContent = defaultMinimumValueContent;
                if (contentIsGreaterThanRecommendation) {
                    aproxContent = defaultMaxValueContent;
                }
                this.setState({ contentValueNotAlowed: true });
                setData(SECOND_STEP, {
                    content: aproxContent,
                    contentHasChanged: false
                });
            }
        }

        if (!!populationChanged && currentPopulation !== populationChanged) {
            this.saveAndRequestRecommendation({ populationValue: populationChanged });
        }
    }

    getMinContinent() {
        const appraisalImport = this.getLivingPlaceData('appraisalImport');
        const groundPrice = this.getLivingPlaceData('groundPrice');
        const minContinentValue = appraisalImport - groundPrice;
        return Math.max(CONTINENT_SLIDER_CONFIG.MIN, minContinentValue);
    }


    getPostAppraisalValues(props) {
        const {
            immInsuranceWizardStep,
            isPostAppraisal,
            setPostAppraisalInitialData,
            immInsuranceState
        } = props;

        if (isPostAppraisal) {
            let minContinentValueFromStep = immInsuranceWizardStep.get('minContinentValue');
            let minContinentValue = this.getMinContinent()
            minContinentValue = Math.max(CONTINENT_SLIDER_CONFIG.MIN, minContinentValue)
            this.setState({
                minContinentValue,
            })
            if (minContinentValueFromStep === 0) {
                let continent = immInsuranceWizardStep.get('continent');
                const postalCode = this.getLivingPlaceData('postalCode');
                continent = Math.max(continent, minContinentValue)
                const existSimulation = immInsuranceState.get('data') !== null;
                if (existSimulation) {
                    setPostAppraisalInitialData(SECOND_STEP, {
                        continent,
                        minContinentValue: continent,
                        postalCode,
                    });
                } else {
                    this.saveAndRequestRecommendation({
                        continent,
                        minContinentValue: continent,
                        postalCode,
                    });
                }
            }
        }
    }

    postalCodeBeforeAppraisal() {
        const {
            immFlagBasedFeatures,
            isPostAppraisal,
        } = this.props;
        const preAppraisalNotificationFlag = immFlagBasedFeatures.get(INSURANCE_RELATED_PRE_APPRAISAL_NOTIFICATION);
        return preAppraisalNotificationFlag && !isPostAppraisal && this.getLivingPlaceData('postalCode');
    }

    postalCodeHasDiscrepancy() {
        const { immInsuranceWizardStep } = this.props;
        return this.postalCodeBeforeAppraisal() && this.getLivingPlaceData('postalCode') !== immInsuranceWizardStep.get('immPostalcode');
    }

    getLivingPlaceData(key) {
        const { immInsuranceState } = this.props;
        const property = immInsuranceState.getIn(['appraisal', 'property']);
        const livingPlaceValue = property ? property.get(key) : null;
        return livingPlaceValue;
    }

    handleChangePropertyCharacter(value) {
        const { immInsuranceWizardStep, recordEvent } = this.props;

        let propertyUsage = immInsuranceWizardStep.get('propertyUsage');
        if (value === PROPERTY_CHARACTER.TENANT) {
            propertyUsage = PROPERTY_USAGE.PRINCIPAL;
        }

        recordEvent(EVENTS_INSURANCE_HOME.STEP_2_PROPERTY_CHARACTER_CHANGE, value);

        this.saveAndRequestRecommendation({
            propertyCharacter: value,
            propertyUsage,
        });
    }

    handleChangePostalCode(evt) {
        const postalCode = evt.target.value;

        this.props.setData(SECOND_STEP, {
            postalCode
        });

        if (postalCode.length === 5) {

            this.props.setData(FOURTH_STEP, {
                additionalInfo: '',
                number: '',
                population: '',
                provinceId: '',
                road: '',
                roadType: '',
                roadTypeName: '',
            });
        }
    }

    handlePostalCodeErrorMessage(postalCode) {
        const requiredFieldText = formatText('common-requiredField');
        const invalidInputText = formatText('insuranceRequestHome-postalCodeErrorMessage');
        const postalCodeErrorMessage = !postalCode.length ? requiredFieldText : invalidInputText;

        return postalCodeErrorMessage
    }

    handleChangeContinent(value) {
        const { setData } = this.props;
        if (this.postalCodeHasDiscrepancy()) {
            setData(SECOND_STEP, {
                sliderPreAppraisalMessageContinent: false
            });
        }
        setData(SECOND_STEP, {
            continent: value
        });
    }

    handleChangeContent(value) {
        const { setData } = this.props;
        if (this.postalCodeHasDiscrepancy()) {
            setData(SECOND_STEP, {
                sliderPreAppraisalMessageContent: false
            });
        }
        setData(SECOND_STEP, {
            content: value
        });
    }

    handleChange(key, value) {
        const {
            immInsuranceWizardStep,
            recordEvent,
        } = this.props;

        let finalValue = value;

        if (key === 'propertyUsage' || key === 'propertyType') {
            if (key == 'propertyType') {
                const currentValue = immInsuranceWizardStep.get('propertyType');
                finalValue = !!value ? value.value : currentValue;
            }
            const event = key === 'propertyUsage' ?
                EVENTS_INSURANCE_HOME.STEP_2_PROPERTY_USAGE_CHANGE :
                EVENTS_INSURANCE_HOME.STEP_2_PROPERTY_TYPE_CHANGE;
            recordEvent(event, finalValue);
        }

        this.saveAndRequestRecommendation({
            [key]: finalValue,
            [`${key}IsDirty`]: true,
        });
    }

    handleToggleModal() {
        this.props.recordEvent(EVENTS_INSURANCE_HOME.STEP_2_OUR_GUIDE_CLICK);
    }

    saveAndRequestRecommendation(newData) {
        const {
            getRecommendation,
            immInsuranceWizardStep,
            isPostAppraisal,
            setData,
         } = this.props;

        const provinceId = this.getProvinceId();
        const defaultData = {
            content: immInsuranceWizardStep.get('content'),
            propertyCharacter: immInsuranceWizardStep.get('propertyCharacter'),
            propertyType: immInsuranceWizardStep.get('propertyType'),
            propertyUsage: immInsuranceWizardStep.get('propertyUsage'),
            size: immInsuranceWizardStep.get('size'),
        };

        if (isPostAppraisal) {
            defaultData.continent = this.getMinContinent();
        }

        const data = merge({}, defaultData, newData);

        setData(SECOND_STEP, data);

        if (provinceId && data.propertyType !== '') {
            this.setState({
                postalCode: immInsuranceWizardStep.get('postalCode'),
                setRecommendation: true,
                updateValues: true,
            }, () => {
                data.provinceId = provinceId;
                getRecommendation(data);
            });
        }
    }

    getProvinceId() {
        const { isPostAppraisal, immInsuranceWizardStep } = this.props;
        const postalCode = isPostAppraisal ? this.getLivingPlaceData('postalCode') : immInsuranceWizardStep.get('postalCode');
        return POSTAL_CODE_REGEX.test(postalCode) && Object.keys(PROVINCES).find(id => id === postalCode.slice(0, 2))
    }

    handleSelectPlanModal(planIdx) {
        const { immInsuranceState, setData, recordEvent } = this.props;

        const plan = immInsuranceState.getIn(['recommendation', planIdx]);

        recordEvent(EVENTS_INSURANCE_HOME.STEP_2_OUR_GUIDE_BUTTON_CLICK, plan.get('type'));

        setData(SECOND_STEP, {
            content: plan.get('content'),
            minimumValueContent: plan.get('minimumValueContent'),
            percentContent: plan.get('percentContent'),
            type: plan.get('type'),
        });
    }

    buildContinentContentRelatedTitle() {
        const { isPostAppraisal } = this.props;
        let contentAndContinentText = "step2ContentAndContinentRelatedText";

        if (isPostAppraisal) {
            contentAndContinentText = "step2ContentAndContinentPostAppraisalRelatedText";
        }

        const titleRelatedContent = (
            <div className="row">
                <div className="col-xs-12">
                    <header className="insurance-request-wizard-step-two-related__header insurance-request-wizard-step-two-related__header--related">
                        <FormattedText value="insuranceRelatedRequest-step2ContentAndContinentRelatedTitle" />
                    </header>
                    <div className="insurance-request-wizard-step-two-related__text">
                        <FormattedText value={`insuranceRelatedRequest-${contentAndContinentText}`} />
                    </div>
                </div>
            </div>
        );

        return titleRelatedContent;
    }

    buildPropertyCharacterAndPropertyUsage(isOwner, immInsuranceWizardStep) {
        const propertyCharacter = immInsuranceWizardStep.get('propertyCharacter');
        const optionDisabled = propertyCharacter !== '' && !isOwner;

        const characterAndUsage = (
            <React.Fragment>
                <div className="insurance-request-wizard-step-two-related__property-character col-sm-6 col-md-5">
                    <RadioButtonGroup
                        className="insurance-request-wizard-step-two-related__radio-group"
                        idPrefix="propertyCharacterRadioGroup"
                        label={formatText('insuranceRequestHome-step2OwnerTenant')}
                        name="propertyCharacterRadioGroup"
                        onChange={this.handleChangePropertyCharacter}
                        selectedValue={propertyCharacter}
                    >
                        <RadioButton
                            label={formatText('insuranceRequestHome-owner')}
                            value={PROPERTY_CHARACTER.OWNER}
                        />
                        <RadioButton
                            label={formatText('insuranceRequestHome-tenant')}
                            value={PROPERTY_CHARACTER.TENANT}
                        />
                    </RadioButtonGroup>
                </div>
                <div className="insurance-request-wizard-step-two-related__property-usage col-sm-6 col-md-5">
                    <RadioButtonGroup
                        className="insurance-request-wizard-step-two-related__radio-group"
                        idPrefix="propertyUsageRadioGroup"
                        label={formatText('insuranceRequestHome-step2PropertyUsage')}
                        name="propertyUsageRadioGroup"
                        onChange={value => this.handleChange('propertyUsage', value)}
                        selectedValue={immInsuranceWizardStep.get('propertyUsage')}
                    >
                        <RadioButton
                            label={formatText('insuranceRequestHome-step2Principal')}
                            value={PROPERTY_USAGE.PRINCIPAL}
                        />
                        <RadioButton
                            disabled={optionDisabled}
                            label={formatText('insuranceRequestHome-step2Secondary')}
                            value={PROPERTY_USAGE.SECONDARY}
                        />
                        <RadioButton
                            disabled={optionDisabled}
                            label={formatText('insuranceRequestHome-step2Rent')}
                            value={PROPERTY_USAGE.RENT}
                        />
                    </RadioButtonGroup>
                </div>
            </React.Fragment>
        );

        return characterAndUsage;
    }

    buildStepTwoSubtitle() {
        const StepTwoSubtitle = (
            <div className="row step-two-subtitle">
                <p className="col-xs-12">
                    <FormattedText value="insuranceRelatedRequest-step2SizeSubtitle" />
                </p>
            </div>
        );

        return StepTwoSubtitle;
    }

    buildSizeWarning(immInsuranceWizardStep, sizeMaxWithoutUnit, insurancesPhone) {
        const sizeWarningVisible = (immInsuranceWizardStep.get('size') === SIZE_SLIDER_CONFIG.MAX) && !__CONTACT_CENTER__;

        if (sizeWarningVisible) {
            return (
                <div className="insurance-request-wizard-step-two-related__message">
                    <OKMessage
                        id="insuranceRequestHomeSizeMessage"
                        type="important"
                        visible={sizeWarningVisible}
                    >
                        <FormattedText value="insuranceRequestHome-step2HighSize" injectedStrings={[sizeMaxWithoutUnit, SIZE_SLIDER_CONFIG.UNIT, insurancesPhone]} />
                    </OKMessage>
                </div>
            );
        } else {
            return null;
        }
    }

    buildHomeSizingComponente(insurancesPhone) {
        const {
            immInsuranceWizardStep,
        } = this.props;

        const step2SubTitle = this.buildStepTwoSubtitle();
        const sizeMinFormatted = `${formatAmount(SIZE_SLIDER_CONFIG.MIN, undefined, 0)}`;
        const sizeMaxFormatted = `${formatAmount(SIZE_SLIDER_CONFIG.MAX, undefined, 0)}`;
        const sizeMaxWithoutUnit = `${formatAmount(SIZE_SLIDER_CONFIG.MAX, undefined, 0)}`;
        const sizeWarningVisible = this.buildSizeWarning(immInsuranceWizardStep, sizeMaxWithoutUnit, insurancesPhone);
        const sliderLabel = <FormattedText value="insuranceRequestHome-step2SizeTitle" />;

        const homeSizingComponent = (
            <div className="row">
                <div className="col-xs-12">
                    <div className="insurance-request-wizard-step-two-related__slider">
                        <OKSliderInput
                            defaultValue={immInsuranceWizardStep.get('size')}
                            extraInfo={step2SubTitle}
                            inputType="format"
                            max={SIZE_SLIDER_CONFIG.MAX}
                            maxLabel={formatText('insuranceRequestHome-step2Max', [sizeMaxFormatted])}
                            min={SIZE_SLIDER_CONFIG.MIN}
                            minLabel={formatText('insuranceRequestHome-step2Min', [sizeMinFormatted])}
                            onChange={value => this.handleChange('size', value)}
                            title={sliderLabel}
                            unit={SIZE_SLIDER_CONFIG.UNIT}
                        />
                    </div>
                    {sizeWarningVisible}
                </div>
            </div>
        );

        return homeSizingComponent;
    }

    buildOkMessage(okMessageObj) {
        const okMessageBoxes = okMessageObj.map((okMessageBox, index) => {
            return (
                <div className="insurance-request-wizard-step-two-related__message" key={index} >
                    <OKMessage
                        id={okMessageBox.id}
                        type="important"
                        visible={okMessageBox.visible}
                    >
                        <FormattedText
                            injectedStrings={okMessageBox.injectedStrings}
                            value={okMessageBox.text}
                        />
                    </OKMessage>
                </div>
            )
        })

        return okMessageBoxes;
    }

    isSliderDisabled(value) {
        const {
            postalCode,
            updateValues,
        } = this.state;
        const {
            immInsuranceState,
            immInsuranceWizardStep
        } = this.props;
        const insurancePostalCode = immInsuranceWizardStep.get('postalCode');
        const postalCodeError = !this.getProvinceId();
        const isFetchingRecommendation = immInsuranceState.get('isFetchingRecommendation');

        return postalCodeError || insurancePostalCode !== postalCode || !value ||
            updateValues && (isFetchingRecommendation || immInsuranceState.get('recommendation').size === 0);
    }

    buildSliderPreAppraisalMessage(poeTerm, sliderMessageVisible) {
        const { immInsuranceState } = this.props;
        const poeContext = __CONTACT_CENTER__ ? 'insuranceRequestHomeCC' : 'insuranceRequestHome';
        const message = `${poeContext}-${poeContext}_${poeTerm}`;
        const hasInsurance = immInsuranceState.get('data');
        const warningVisible = this.postalCodeHasDiscrepancy() && sliderMessageVisible && hasInsurance;

        return warningVisible
            ? (
                <div className="insurance-request-wizard-step-two-related__content-message">
                    <OKMessage
                        id="insuranceRequestSliderPreAppraisalMessage"
                        type="important"
                        visible={warningVisible}
                    >
                        <FormattedText value={message} />
                    </OKMessage>
                </div>
            )
            : null;
    }

    buildContentSliderComponent() {
        const { maxContentPassed } = this.state;
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardStep,
            isPostAppraisal,
        } = this.props;

        const recommendationsData = immInsuranceState.get('recommendation');
        const insurancesRecommendationFactors = !!immFlagBasedFeatures.get(INSURANCES_RECOMMENDATION_FACTORS);
        const defaultMinimumValueContent = recommendationsData.getIn([0, 'defaultMinimumValueContent'], CONTENT_SLIDER_CONFIG.MIN);
        const contentMinValue = insurancesRecommendationFactors ? defaultMinimumValueContent : CONTENT_SLIDER_CONFIG.MIN;
        const maxContentValue = this.getMaxContentValue();
        const contentMaxFormatted = formatText('insuranceRequestHome-step2Max', [formatAmount(maxContentValue, undefined, 0)]);
        const contentMinFormatted = formatText('insuranceRequestHome-step2Min', [formatAmount(contentMinValue, undefined, 0)]);
        const insurancesPhone = formatText('insuranceRequestHome-openbankInsurancesPhone');
        const contentDefaultValue = immInsuranceWizardStep.get('content');
        const continentDefaultValue = immInsuranceWizardStep.get('continent');
        const isOwnerAndContentIsGreaterThanContinent = immInsuranceWizardStep.get('propertyCharacter') === PROPERTY_CHARACTER.OWNER && (contentDefaultValue > continentDefaultValue);

        const isContentDisabled = this.isSliderDisabled(contentDefaultValue);
        const isLowContentWarningVisible = this.isLowContentWarningVisible();
        const disclaimerContentLimitExceededCC = __CONTACT_CENTER__ ? this.buildDisclaimerContentLimitExceededCC() : null;
        const okMessageContent = [
            {
                id: 'insuranceRequestHomeContentMessage',
                injectedStrings: [],
                text: 'insuranceRequestHome-step2LowContent',
                visible: isLowContentWarningVisible,
            },
            {
                id: 'insuranceRequestHomeMaxContentMessage',
                injectedStrings: [maxContentValue, EURO_SYMBOL, insurancesPhone],
                text: 'insuranceRequestHome-step2ContentMaxReachedMsg',
                visible: maxContentPassed && !__CONTACT_CENTER__,
            },
            {
                id: 'insuranceRequestHomecontentGreaterThanContinent',
                injectedStrings: [],
                text: 'insuranceRelatedRequest-insuranceRelatedRequest_contentGreaterThanContinentMessage',
                visible: insurancesRecommendationFactors && isOwnerAndContentIsGreaterThanContinent,
            },
        ]

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="insurance-request-wizard-step-two-related__slider insurance-request-wizard-step-two-related__slider--small">
                        <InsurancesRequestWizardStep2SliderLabel
                            isPostAppraisal={isPostAppraisal}
                            labelName={"insuranceRequestHome-summaryContent"}
                            tooltipCont={'insuranceRequestHome-step2ContentTooltip'}
                        />
                        <OKSliderInput
                            defaultValue={contentDefaultValue}
                            disabled={!isPostAppraisal && isContentDisabled}
                            id="insuranceRequestHomeContentSlider"
                            inputType="format"
                            max={maxContentValue}
                            maxLabel={contentMaxFormatted}
                            min={contentMinValue}
                            minLabel={contentMinFormatted}
                            onChange={this.handleChangeContent}
                            step={100}
                            unit={EURO_SYMBOL}
                        />
                    </div>
                    {disclaimerContentLimitExceededCC}
                    {this.buildOkMessage(okMessageContent)}
                    {isPostAppraisal && this.buildPostAppraisalWarningMessage()}
                    {this.buildSliderPreAppraisalMessage('contentHasChanged', immInsuranceWizardStep.get('sliderPreAppraisalMessageContent'))}
                </div>
            </div>
        )
    }

    getMaxContentValue() {
        const { immInsuranceState } = this.props;
        const recommendationsData = immInsuranceState.get('recommendation');
        const defaultMax = __CONTACT_CENTER__ ? CONTENT_SLIDER_CONFIG.MAX_PRINCIPAL_CC : CONTENT_SLIDER_CONFIG.MAX;

        return recommendationsData.getIn([0, 'defaultMaxValueContent'], defaultMax);
    }

    isLowContentWarningVisible() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardStep,
            isPostAppraisal,
        } = this.props;

        const maxContentValue = this.getMaxContentValue();
        const content = immInsuranceWizardStep.get('content');
        const contentIsNotDisabled = !this.isSliderDisabled(content);
        const hasSimulation = this.hasSimulation();
        const isContentLimitExceedCC = this.isContentLimitExceededCC();
        const minimumValueContent = !!immFlagBasedFeatures.get(INSURANCES_RECOMMENDATION_FACTORS) ?
            immInsuranceState.getIn(['recommendation', 0, 'minimumValueContent']) :
            immInsuranceState.getIn(['recommendation', 0, 'content']);
        const contentWarningVisible = content < minimumValueContent && content < maxContentValue;
        const lowContentWarningVisible = isPostAppraisal
            ? !hasSimulation && contentWarningVisible
            : contentWarningVisible && contentIsNotDisabled;

        return isContentLimitExceedCC ? false : lowContentWarningVisible;
    }

    buildDisclaimerContentLimitExceededCC() {
        const isContentLimitExceedCC = this.isContentLimitExceededCC();
        const maxContentValueWeb = this.getMaxContentValue();
        const poEditorPrefix = 'insuranceRequestHomeCC-insuranceRequestHomeCC';

        return (
            <div className="insurance-request-wizard-step-two-related__content-limited-exceeded">
                <OKMessage
                    id="contentLimitExceededCC"
                    type="important"
                    visible={isContentLimitExceedCC}
                >
                    <FormattedText
                        injectedStrings={[formatAmount(maxContentValueWeb, undefined, 0), EURO_SYMBOL]}
                        value={`${poEditorPrefix}_disclaimerMessageContentLimitedExceeded`}
                    />
                </OKMessage>
            </div>
        );
    }

    isContentLimitExceededCC() {
        const { immInsuranceWizardStep } = this.props;

        const maxContentValueWeb = this.getMaxContentValue();
        let contentLimitExceeded = false;

        if (__CONTACT_CENTER__) {
            contentLimitExceeded = immInsuranceWizardStep.get('content') > maxContentValueWeb;
        }

        return contentLimitExceeded;
    }

    buildPostAppraisalWarningMessage() {
        const { immInsuranceWizardStep } = this.props;

        const baseMessage = "insuranceRequestHome";
        const simulationMessage = `${baseMessage}-${baseMessage}_postAppraisalSimulationContentDisclaimer`;
        const noSimulationMessage = `${baseMessage}-${baseMessage}_postAppraisalNoSimulationContentDisclaimer`;
        const contentHasChanged = immInsuranceWizardStep.get('contentHasChanged');
        const warningVisible = !contentHasChanged && (!this.hasSimulation() || this.state.contentValueNotAlowed);
        const warningMessage = this.hasSimulation() ? simulationMessage : noSimulationMessage;

        return warningVisible
            ? (
                <div className="insurance-request-wizard-step-two-related__content-message">
                    <OKMessage
                        id="insuranceRequestHomeMaxContentMessage"
                        type="important"
                        visible={warningVisible}
                    >
                        <FormattedText value={warningMessage} />
                    </OKMessage>
                </div>
            )
            : null;
    }

    hasSimulation() {
        const { immInsuranceState } = this.props;

        return !!immInsuranceState.get('data') && !immInsuranceState.get('data').isEmpty();
    }

    buildStepValidationError() {
        return (
            <div className="row">
                <div className="col-xs-12 insurance-request-wizard-step-two-related__field-errors-message">
                    <OKMessage type="warning">
                        <FormattedText value="insuranceRequestHome-stepValidationError" />
                    </OKMessage>
                </div>
            </div>
        );
    }

    buildContinentSliderContent() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardStep,
            isPostAppraisal,
        } = this.props;
        const {
            lowContinentWarningVisible,
        } = this.state;
        const recommendationsData = immInsuranceState.get('recommendation');
        const continentDefaultValue = immInsuranceWizardStep.get('continent');
        const continentRecommendation = recommendationsData.getIn([0, 'continent']);
        const supraContinent = recommendationsData.getIn([0, 'maxValueContinent']);
        const currentContinent = immInsuranceState.getIn(['data', 'continent'], 0);
        const isOwner = immInsuranceWizardStep.get('propertyCharacter') === PROPERTY_CHARACTER.OWNER;
        const showContinentHasChangedDisclaimer = isPostAppraisal && (currentContinent !== this.getMinContinent()) && !!currentContinent;
        const insurancesRecommendationFactors = !!immFlagBasedFeatures.get(INSURANCES_RECOMMENDATION_FACTORS);
        const defaultMinimumValueContinent = recommendationsData.getIn([0, 'defaultMinimumValueContinent'], CONTINENT_SLIDER_CONFIG.MIN);
        const continentMinValueContinent = insurancesRecommendationFactors ? defaultMinimumValueContinent : CONTINENT_SLIDER_CONFIG.MIN;
        const continentMinValue = !isPostAppraisal
            ? continentMinValueContinent
            : this.state.minContinentValue
        const continentMaxValue = recommendationsData.getIn([0, 'defaultMaxValueContinent'], CONTINENT_SLIDER_CONFIG.MAX);
        const continentWarningVisible = isOwner && immInsuranceWizardStep.get('continent') === continentMaxValue;
        const continentMinFormatted = formatAmount(continentMinValue, undefined, 0);
        const continentMaxFormatted = formatAmount(continentMaxValue, undefined, 0);
        const continentTooltip = 'insuranceRequestHome-step2ContinentTooltip';
        const continentDisabled = this.isSliderDisabled(continentDefaultValue);
        const insurancesPhone = formatText('insuranceRequestHome-openbankInsurancesPhone');
        const okMessageContinent = [
            {
                id: 'insuranceRequestHomeContinentMessage',
                injectedStrings: [continentMaxFormatted, EURO_SYMBOL, insurancesPhone],
                text: 'insuranceRequestHome-step2HighContinent',
                visible: continentWarningVisible && !__CONTACT_CENTER__,
            },
            {
                id: 'insuranceRequestHomeLowContinentMessage',
                injectedStrings: [],
                text: 'insuranceRequestHome-step2LowContinent',
                visible: lowContinentWarningVisible && !continentDisabled,
            },
            {
                id: 'insuranceRequestHomeSupraContinentMessage',
                injectedStrings: [],
                text: 'insuranceRelatedRequest-insuranceRelatedRequest_supraInsuranceMessage',
                visible: isOwner && !!supraContinent && supraContinent !== continentRecommendation && continentDefaultValue > supraContinent,
            },
        ];
        const labelMinMaxValues = {
            MIN: defaultMinimumValueContinent,
            MAX: continentMaxValue,
        };

        return (
            <div className="row">
                <div className="col-xs-12">
                    <div className="insurance-request-wizard-step-two-related__slider insurance-request-wizard-step-two-related__slider--small">
                        <InsurancesRequestWizardStep2SliderLabel
                            continentIcon={true}
                            continentValue={continentMinFormatted}
                            isPostAppraisal={isPostAppraisal}
                            labelName={"insuranceRequestHome-summaryContinent"}
                            minMaxValues={labelMinMaxValues}
                            showLabelDetails={isPostAppraisal}
                            tooltipCont={continentTooltip}
                        />
                        {showContinentHasChangedDisclaimer &&
                            <div className="insurance-request-wizard-step-two-related__continent-message">
                                <OKMessage
                                    id="insuranceRequestPostAppraisalContinentDisclaimer"
                                    type="important"
                                    visible={true}
                                >
                                    <FormattedText value="insuranceRequestHome-insuranceRequestHome_postAppraisalContinentDisclaimer" />
                                </OKMessage>
                            </div>
                        }
                        {!isPostAppraisal &&
                            <OKSliderInput
                                defaultValue={continentDefaultValue}
                                disabled={!isPostAppraisal && continentDisabled}
                                id="insuranceRequestHomeContinentSlider"
                                inputType="format"
                                max={continentMaxValue}
                                maxLabel={formatText('insuranceRequestHome-step2Max', [continentMaxFormatted])}
                                min={continentMinValue}
                                minLabel={formatText('insuranceRequestHome-step2Min', [continentMinFormatted])}
                                onChange={this.handleChangeContinent}
                                step={100}
                                unit={EURO_SYMBOL}
                            />
                        }
                    </div>
                    {this.buildSliderPreAppraisalMessage('continentHasChanged', immInsuranceWizardStep.get('sliderPreAppraisalMessageContinent'))}
                    {this.buildOkMessage(okMessageContinent)}
                </div>
            </div>
        );
    }

    buildContinentAndContendSliders() {
        const {
            immInsuranceState,
            immInsuranceWizardStep,
        } = this.props;
        const recommendationsData = immInsuranceState.get('recommendation');
        const maxContentValidation = this.getMaxContentValue();
        const recommendationsDataToJS = recommendationsData.toJS();
        const recommendationsExceedMax = recommendationsDataToJS.filter(plan => plan.content > maxContentValidation);
        const isFetchingRecommendation = immInsuranceState.get('isFetchingRecommendation');
        const contentDefaultValue = immInsuranceWizardStep.get('content');
        const continentDefaultValue = immInsuranceWizardStep.get('continent');
        const contentDisabled = this.isSliderDisabled(contentDefaultValue);
        const continentDisabled = this.isSliderDisabled(continentDefaultValue);
        const showGuideModal = !isFetchingRecommendation && continentDefaultValue &&
            !continentDisabled && !contentDisabled;
        const showGuideText = recommendationsDataToJS.length > 0 && !recommendationsExceedMax.length && showGuideModal;
        const contentAndContinentRelatedTitle = this.buildContinentContentRelatedTitle();
        const continent = this.buildContinentSliderContent();
        const content = this.buildContentSliderComponent();

        return (
            <React.Fragment>
                {contentAndContinentRelatedTitle}
                {continent}
                {content}
                <InsuranceRequestWizardGuide
                    isRelated
                    onHandleToggleModal={this.handleToggleModal}
                    onSelectPlanModal={this.handleSelectPlanModal}
                    recommendationsData={recommendationsDataToJS}
                    showGuideModal={showGuideModal}
                    showGuideText={showGuideText}
                />
            </React.Fragment>
        );
    }

    buildPostalCodeMessage() {
        return this.postalCodeBeforeAppraisal() ? (
            <div className="insurance-request-wizard-step-two-related__postal-code-message col-xs-12 col-md-12">
                <OKMessage>
                    <FormattedText value="insuranceRequestHome-insuranceRequestHome_modifyPostalCodeMessage" />
                </OKMessage>
            </div>
        ) : null;
    }

    render() {
        const {
            changeErrorPopulation,
            changeErrorPostalCode,
            clearPostalCodeError,
            getPopulationData,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardStep,
            isPostAppraisal,
            recordEvent,
            setData,
        } = this.props;
        const postalCode = immInsuranceWizardStep.get('postalCode');
        const postalCodeLivingPlace = this.getLivingPlaceData('postalCode');
        const postalCodeError = immInsuranceWizardStep.get('postalCodeError');
        const populationError = immInsuranceWizardStep.get('populationError');
        const postalCodeInputError = immInsuranceWizardStep.get('fieldErrors') && (postalCodeError || populationError);
        const isInsuranceUsabilityImprovementsEnabled = immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const stepValidationError = !isInsuranceUsabilityImprovementsEnabled && postalCodeInputError ? this.buildStepValidationError() : null;
        const propertyTypeValue = immInsuranceWizardStep.get('propertyType')
        const insurancesPhone = formatText('insuranceRequestHome-openbankInsurancesPhone');
        const preAppraisalNotificationFlag = immFlagBasedFeatures.get(INSURANCE_RELATED_PRE_APPRAISAL_NOTIFICATION);
        const isPopulationDataUpdated = (postalCodeLivingPlace === postalCode) || !postalCodeLivingPlace;
        const hasNotLivingPlaceAndInsurance = !immInsuranceState.get('data') && !postalCodeLivingPlace;
        const showPostalCodePopulation = (!isPostAppraisal && !preAppraisalNotificationFlag) || hasNotLivingPlaceAndInsurance || (!postalCode && !isPostAppraisal) || (postalCode && isPopulationDataUpdated);
        const postalCodePopulationContent = showPostalCodePopulation ? (
            <InsuranceRequestPostalCodePopulation
                changeErrorPopulation={changeErrorPopulation}
                changeErrorPostalCode={changeErrorPostalCode}
                clearPostalCodeError={clearPostalCodeError}
                getPopulationData={getPopulationData}
                immInsuranceWizardStep={immInsuranceWizardStep}
                isPostAppraisal={isPostAppraisal}
                populationClassName="insurance-request-wizard-step-two-related col-xs-12 col-md-4"
                recordEvent={recordEvent}
                saveAndRequestRecommendation={this.saveAndRequestRecommendation}
                setData={setData}
                tooltipText="insuranceRequestHome-insuranceRequestHome_mesageTooltipPopulationRelated"
                disablePostalCode={this.postalCodeBeforeAppraisal()}
            />
        ) : null;
        const homeSizingComponent = !isPostAppraisal ? this.buildHomeSizingComponente(insurancesPhone) : null;
        const isValid = immInsuranceWizardStep.get('valid');
        const recommendationIsEmpty = immInsuranceState.get('recommendation').size === 0
        const continentAndContent = !isInsuranceUsabilityImprovementsEnabled || isValid && !recommendationIsEmpty ? this.buildContinentAndContendSliders() : null;
        const placeholder = isInsuranceUsabilityImprovementsEnabled ? formatText('insuranceRequestHome-insuranceRequestHome_step2PropertyTypePlaceholder') : null;

        return (
            <div className="insurance-request-wizard-step-two-related">
                <div className="row">
                    <header className="insurance-request-wizard-step-two-related__header">
                        <FormattedText value="insuranceRelatedRequest-step2Title" />
                    </header>
                </div>
                {stepValidationError}
                <div className="row">
                    <div className="col-xs-4 col-md-4">
                        <OKSelect
                            label={formatText('insuranceRequestHome-step2PropertyType')}
                            name="propertyTypeSelect"
                            onChange={op => this.handleChange('propertyType', op)}
                            options={getPropertyTypeOptions()}
                            placeholder={placeholder}
                            searchable={false}
                            value={propertyTypeValue}
                        />
                    </div>
                    {postalCodePopulationContent}
                    {this.buildPostalCodeMessage()}
                </div>
                {homeSizingComponent}
                {continentAndContent}
            </div>
        );
    }
}

InsuranceRequestWizardStep2Related.propTypes = {
    changeErrorPopulation: PropTypes.func.isRequired,
    changeErrorPostalCode: PropTypes.func.isRequired,
    clearPostalCodeError: PropTypes.func.isRequired,
    getPopulationData: PropTypes.func.isRequired,
    getRecommendation: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    isPostAppraisal: PropTypes.bool,
    isRnc: PropTypes.bool,
    recordEvent: PropTypes.func.isRequired,
    savePreviousId: PropTypes.func,
    setData: PropTypes.func.isRequired,
};

InsuranceRequestWizardStep2Related.defaultProps = {
    isPostAppraisal: false,
    isRnc: false,
    savePreviousId: () => { },
};

module.exports = InsuranceRequestWizardStep2Related;
